import moment from 'moment-timezone';
import {
	AGENTS_TABLE_TYPE,
	EDITING_COMPANY_TABLE_TYPE,
	EDITOR_AVAILABLE_PHOTOSHOOT_TABLE_TYPE,
	EDITORS_TABLE_TYPE,
	FINANCE_TABLE_TYPE,
	INVITE_CODE_TABLE_TYPE,
	LISTINGS_TABLE_TYPE,
	OPTIONS_TABLE_TYPE,
	PARTNER_PACKAGE_TABLE_TYPE,
	PHOTOGRAPHER_AVAILABLE_PHOTOSHOOT_TABLE_TYPE,
	PHOTOGRAPHERS_TABLE_TYPE,
	SALESMEN_TABLE_TYPE,
	SERVICE_REQUEST_TABLE_TYPE,
	SERVICES_TABLE_TYPE
} from './config';

export const getOrderByVariables = (variables, matchingPath, props, type) => {
	let orderBy;

	if (props.filters[matchingPath]) {
		orderBy = props.filters[matchingPath].orderBy;
	}

	switch (type) {
		case SERVICES_TABLE_TYPE:
		case FINANCE_TABLE_TYPE:
		case PARTNER_PACKAGE_TABLE_TYPE:
		case PHOTOGRAPHER_AVAILABLE_PHOTOSHOOT_TABLE_TYPE:
		case EDITOR_AVAILABLE_PHOTOSHOOT_TABLE_TYPE:
			variables.order = [[orderBy ? orderBy : 'serviceDate', 'DESC']];
			break;
		case AGENTS_TABLE_TYPE:
		case PHOTOGRAPHERS_TABLE_TYPE:
		case SALESMEN_TABLE_TYPE:
		case EDITORS_TABLE_TYPE:
		case SERVICE_REQUEST_TABLE_TYPE:
			variables.order = [[orderBy ? orderBy : 'createdAt', 'ASC']];
			break;
		case OPTIONS_TABLE_TYPE:
			variables.order = [[orderBy ? orderBy : 'createdAt', 'ASC']];
			break;
		case LISTINGS_TABLE_TYPE:
			variables.order = [[orderBy ? orderBy : 'updatedAt', 'DESC']];
			break;
		default:
			break;
	}
	return variables;
};

export const getPaginatedTableVariablesByTypeAndSearch = (limit, type, props, baseVariables) => {
	const matchingPath = props.history.location.pathname;
	let variables = { ...baseVariables };
	variables = getOrderByVariables(variables, matchingPath, props, type);

	const page = props.filters[matchingPath] ? (props.filters[matchingPath].page ? props.filters[matchingPath].page : 1) : 1;

	variables.offset = limit * (page - 1);
	variables.limit = limit;

	if (!props.filters[matchingPath]) return variables;

	switch (type) {
		case SERVICES_TABLE_TYPE:
		case FINANCE_TABLE_TYPE:
		case PARTNER_PACKAGE_TABLE_TYPE:
		case PHOTOGRAPHER_AVAILABLE_PHOTOSHOOT_TABLE_TYPE:
		case EDITOR_AVAILABLE_PHOTOSHOOT_TABLE_TYPE:
			if (props.filters[matchingPath].status) {
				if (props.filters[matchingPath].status.value !== 'Any') {
					variables.q['status'] = {
						op_eq: props.filters[matchingPath].status.value
					};
				}
			}
			if (props.filters[matchingPath].region) {
				variables.q['regionId'] = {
					op_eq: props.filters[matchingPath].region.value.id
				};
			}
			if (props.filters[matchingPath]['serviceType']) {
				variables.q['type'] = {
					op_eq: props.filters[matchingPath]['serviceType'].value
				};
			}

			if (props.filters[matchingPath].search) {
				variables.q[props.filters[matchingPath].search_field] = props.filters[matchingPath].search;
			}
			if (props.filters[matchingPath].startDate && props.filters[matchingPath].endDate) {
				variables.q['op_and'] = [
					{
						serviceDate: {
							op_gte: moment(props.filters[matchingPath].startDate).startOf('day')
						}
					},
					{
						serviceDate: {
							op_lte: moment(props.filters[matchingPath].endDate).endOf('day')
						}
					}
				];
			} else if (props.filters[matchingPath].startDate) {
				let startOfSelectedDay = moment(props.filters[matchingPath].startDate).startOf('day');
				let endOfSelectedDay = moment(props.filters[matchingPath].startDate).endOf('day');
				variables.q['serviceDate'] = [{ serviceDate: { op_gte: startOfSelectedDay } }, { serviceDate: { op_lte: endOfSelectedDay } }];
			}
			break;
		case AGENTS_TABLE_TYPE:
		case PHOTOGRAPHERS_TABLE_TYPE:
		case SALESMEN_TABLE_TYPE:
		case EDITORS_TABLE_TYPE:
			if (props.filters[matchingPath].region) {
				variables.regionId = props.filters[matchingPath].region.value.id;
			}
			if (props.filters[matchingPath].search) {
				variables.q = {
					...variables.q,
					op_or: [
						{ name: { op_iLike: '%' + props.filters[matchingPath].search + '%' } },
						{ email: { op_iLike: '%' + props.filters[matchingPath].search + '%' } }
					]
				};
			}
			break;
		case EDITING_COMPANY_TABLE_TYPE:
			if (props.filters[matchingPath].search) {
				variables.q['name'] = {
					op_iLike: '%' + props.filters[matchingPath].search + '%'
				};
			}
			break;
		case OPTIONS_TABLE_TYPE:
			if (props.filters[matchingPath].search) {
				variables.q['name'] = {
					op_iLike: '%' + props.filters[matchingPath].search + '%'
				};
			}
			break;
		case LISTINGS_TABLE_TYPE:
			if (props.filters[matchingPath].search) {
				variables.q[props.filters[matchingPath].search_field] = props.filters[matchingPath].search;
			}
			break;
		case INVITE_CODE_TABLE_TYPE:
			if (props.filters[matchingPath].search) {
				variables.q['inviteCode'] = {
					op_iLike: '%' + props.filters[matchingPath].search + '%'
				};
			}
			break;

		default:
			break;
	}

	if (variables.q === {}) delete variables.q;

	return variables;
};
